export default {
  closeCurrent: 'Close current',
  closeRight: 'Close right',
  closeLeft: 'Close left',
  closeAll: 'Close all',
  cannotCloseLast: 'Can not close the last label',
  noLeft: 'No left label',
  noRight: 'No right label'
}
